import { render, staticRenderFns } from "./LpuReviews.vue?vue&type=template&id=29a23bd2&scoped=true&"
import script from "./LpuReviews.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuReviews.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuReviews.vue?vue&type=style&index=0&id=29a23bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a23bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a23bd2')) {
      api.createRecord('29a23bd2', component.options)
    } else {
      api.reload('29a23bd2', component.options)
    }
    module.hot.accept("./LpuReviews.vue?vue&type=template&id=29a23bd2&scoped=true&", function () {
      api.rerender('29a23bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/LpuReviews.vue"
export default component.exports